/*****************/
/* INITIAL STATE */
/*****************/
type SlideoutState = {
  slideout: SlideoutProperties | null | undefined;
};

const initialState: SlideoutState = {
  slideout: null,
};

/*********/
/* TYPES */
/*********/
interface SlideoutProperties {
  title?: string;
  content?: any;
  slideoutProps?: any;
}

export enum SlideoutActionTypes {
  SHOW_SLIDEOUT = "SHOW_SLIDEOUT",
  HIDE_SLIDEOUT = "HIDE_SLIDEOUT",
}

export interface SlideoutAction {
  type: SlideoutActionTypes;
  payload?: SlideoutProperties;
}

/*******************/
/* ACTION CREATORS */
/*******************/
export function showSlideout(payload: SlideoutProperties): SlideoutAction {
  return {
    type: SlideoutActionTypes.SHOW_SLIDEOUT,
    payload,
  };
}

export function hideSlideout(): SlideoutAction {
  return {
    type: SlideoutActionTypes.HIDE_SLIDEOUT,
  };
}

/***********/
/* REDUCER */
/***********/
function slideoutReducer(state = initialState, action: SlideoutAction): SlideoutState {
  switch (action.type) {
    case SlideoutActionTypes.SHOW_SLIDEOUT:
      return {
        ...state,
        slideout: action.payload,
      };
    case SlideoutActionTypes.HIDE_SLIDEOUT:
      return {
        ...state,
        slideout: null,
      };
    default:
      return state;
  }
}

export default slideoutReducer;